import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { ILicitacaoPagedResponse } from "models/response/licitacao-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getModalidadeColor } from "utils/modalidade-colors";

type LicitacoesTableProps = {
    currentItems: PaginationResponse<ILicitacaoPagedResponse>;
};

export const LicitacoesTable: React.FC<LicitacoesTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhuma licitação encontrada.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nº Licitação</TableCell>
                        <TableCell>Órgão</TableCell>
                        <TableCell>Modalidade</TableCell>
                        <TableCell>Situação</TableCell>
                        <TableCell>Abertura</TableCell>
                        <TableCell align="right">Valor Estimado</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((licitacao) => (
                        <TableRow key={licitacao.id}>
                            <TableCell>{licitacao.numLicitacao}</TableCell>
                            <TableCell>{licitacao.orgaoName}</TableCell>
                            <TableCell>
                                <Chip label={licitacao.modalidadeName} size="small" style={getModalidadeColor(licitacao.modalidadeName)} />
                            </TableCell>
                            <TableCell><Chip label={licitacao.situacaoName} size="small" /></TableCell>
                            <TableCell>{new Date(licitacao.dtaHoraAbertura).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell align="right">
                                {licitacao.valorEstimado != null
                                    ? licitacao.valorEstimado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                    : licitacao.textoJustificativaValorEstimado}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/licitacoes/${licitacao.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
